import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountReducer from '../reducers/account.reducer';

export const selectState = createFeatureSelector<fromAccountReducer.State>(
  fromAccountReducer.featureKey
);

export const getUserProfile = createSelector(selectState, (state) => state.userProfile);
export const getApplicantDetails = createSelector(selectState, (state) => state.applicantDetails);